import { Button, Container, Form, InputGroup } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import Styles from '../../styles/common/pages.module.css';
import Style from '../../styles/common/setting.module.css';
import { FaEyeSlash, FaEye, FaEdit } from 'react-icons/fa';
import { useProfileSettingHelper } from '../../helpers/pages/ProfileSettingHelper';

const ProfileSetting = () => {
    const {
        fullName,
        setFullName,
        username,
        setUsername,
        email,
        setEmail,
        phone,
        setPhone,
        oldPassword,
        setOldPassword,
        newPassword,
        setNewPassword,
        showOldPassword,
        setShowOldPassword,
        showPassword,
        setShowPassword,
        isEditingPassword,
        setIsEditingPassword,
        isDirty,
        formErrors,
        handleSubmit,
        isUserDetails,
        setIsDirty,
        handleDeleteAccount, // 👈 return करो
        // NEW photo bits
        fileInputRef,
        photoPreview,
        photoError,
        openFilePicker,
        handlePhotoChange,
        handleDeletePhoto,
        loadProfilePhoto
    } = useProfileSettingHelper();

    return (
        <>
            <Helmet>
                <title>Profile Settings - Mohit's Shopping App</title>
                <meta
                    name="description"
                    content="Manage your profile settings including name, email, password, and more at Mohit's Shopping App."
                />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta property="og:title" content="Profile Settings - Mohit's Shopping App" />
                <meta
                    property="og:description"
                    content="Update your personal information and account preferences in the Profile Settings section."
                />
                <meta
                    property="og:image"
                    content={`${process.env.PUBLIC_URL}/favicon.png`}
                />
                <meta
                    property="og:url"
                    content="https://mohit-online-shopping.netlify.app/settings"
                />
            </Helmet>

            <h1 className="visually-hidden">Profile Settings - Mohit's Shopping App</h1>
            {/* This is the First Section of Home Page */}
            <section className={Styles.headSec}>
                <Container>
                    <h2>Profile Settings</h2>
                </Container>
            </section>
            <section>
                <Container className={Style.profileWrapper}>
                    {/* ✅ Left Section (Profile Photo + Buttons) */}
                    <div className={Style.profileLeft}>
                        {/* {photoPreview ? (
                            // 👀 Agar user ne abhi nayi photo select ki hai
                            <img src={photoPreview} alt="Profile" className={Style.profileImage} />
                        ) : loadProfilePhoto ? (
                            // 👀 Agar Redux/DB me profilePhoto hai
                            <img
                                src={`${process.env.REACT_APP_API_URL}${loadProfilePhoto}`}
                                alt="Profile"
                                className={Style.profileImage}
                            />
                        ) : isUserDetails?.name ? (
                            // 👀 Agar photo nahi hai but naam hai
                            <div className={Style.userInitial}>
                                {isUserDetails.name.charAt(0).toUpperCase()}
                            </div>
                        ) : (
                            // 👀 Agar kuch bhi nahi hai
                            <div className={Style.userInitial}>?</div>
                        )} */}
                        {photoPreview ? (
                            <img src={photoPreview} alt="Profile" className={Style.profileImage} />
                        ) : loadProfilePhoto && loadProfilePhoto !== "null" && loadProfilePhoto !== "" ? (
                            <img
                                src={`${process.env.REACT_APP_API_URL}${loadProfilePhoto}`}
                                alt="Profile"
                                className={Style.profileImage}
                                onError={(e) => {
                                    (e.target as HTMLImageElement).style.display = "none";
                                }}
                            />
                        ) : isUserDetails?.name ? (
                            <div className={Style.userInitial}>
                                {isUserDetails.name.charAt(0).toUpperCase()}
                            </div>
                        ) : (
                            <div className={Style.userInitial}>?</div>
                        )}


                        {/* Hidden file input */}
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept="image/jpeg,image/jpg,image/png,image/webp"
                            style={{ display: "none" }}
                            onChange={(e) => handlePhotoChange(e.target.files?.[0] || null)}
                        />

                        <div className={Style.actionButtons}>
                            <Button variant="primary" size="sm" onClick={openFilePicker}>
                                Change Photo
                            </Button>
                            <Button
                                variant="danger"
                                size="sm"
                                onClick={handleDeletePhoto}
                                disabled={!photoPreview && !loadProfilePhoto}
                            >
                                Delete Photo
                            </Button>
                        </div>

                        {photoError && <div className="text-danger mt-2">{photoError}</div>}
                    </div>

                    {/* ✅ Right Section (Profile Details) */}
                    <div className={Style.profileRight}>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label>Full Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={fullName}
                                    onChange={(e) => {
                                        setFullName(e.target.value);
                                        setIsDirty(true);
                                    }}
                                />
                                {formErrors.find(err => err.field === "fullName") && (
                                    <div className="text-danger">
                                        {formErrors.find(err => err.field === "fullName")?.message}
                                    </div>
                                )}
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Username</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={username}
                                    onChange={(e) => {
                                        setUsername(e.target.value);
                                        setIsDirty(true);
                                    }}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    value={email}
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                        setIsDirty(true);
                                    }}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={phone}
                                    onChange={(e) => {
                                        setPhone(e.target.value);
                                        setIsDirty(true);
                                    }}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Current Password</Form.Label>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '0.375rem 0.75rem',
                                        border: '1px solid #ced4da',
                                        borderRadius: '0.375rem',
                                        backgroundColor: '#f8f9fa',
                                        color: '#6c757d',
                                        userSelect: 'none',
                                        justifyContent: 'space-between',
                                        cursor: 'default'
                                    }}
                                >
                                    <span>***************</span>
                                    <FaEdit
                                        style={{ cursor: 'pointer' }}
                                        title="Edit Password"
                                        onClick={() => setIsEditingPassword((prev) => !prev)}
                                    />
                                </div>
                            </Form.Group>

                            {/* Show inputs only if editing */}
                            {isEditingPassword && (
                                <>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Old Password</Form.Label>
                                        <InputGroup>
                                            <Form.Control
                                                type={showOldPassword ? 'text' : 'password'}
                                                placeholder="Enter old password"
                                                value={oldPassword}
                                                onChange={(e) => {
                                                    setOldPassword(e.target.value);
                                                    setIsDirty(true);
                                                }}
                                            />
                                            <Button
                                                variant="outline-secondary"
                                                onClick={() => setShowOldPassword((prev) => !prev)}
                                            >
                                                {showOldPassword ? <FaEyeSlash /> : <FaEye />}
                                            </Button>
                                        </InputGroup>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>New Password</Form.Label>
                                        <InputGroup>
                                            <Form.Control
                                                type={showPassword ? 'text' : 'password'}
                                                placeholder="Enter new password"
                                                value={newPassword}
                                                onChange={(e) => {
                                                    setNewPassword(e.target.value);
                                                    setIsDirty(true);
                                                }}
                                            />
                                            <Button
                                                variant="outline-secondary"
                                                onClick={() => setShowPassword((prev) => !prev)}
                                            >
                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                            </Button>
                                        </InputGroup>
                                    </Form.Group>
                                </>
                            )}

                            <Button variant="success" type="submit" disabled={!isDirty}>
                                Save Changes
                            </Button>

                            <Button variant="danger"
                                onClick={handleDeleteAccount}
                                className="ms-2">
                                Delete Account
                            </Button>
                        </Form>
                    </div>
                </Container>
            </section >
        </>
    )
}

export default ProfileSetting
